import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "form-parent" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", { class: "subtitle-3" }, "Personal information", -1)
const _hoisted_3 = { class: "grey-form-card" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h3", { class: "subtitle-3" }, "User role", -1)
const _hoisted_5 = { class: "grey-form-card" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-down el-icon--right" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("h3", { class: "subtitle-3" }, "User language", -1)
const _hoisted_8 = { class: "grey-form-card" }
const _hoisted_9 = /*#__PURE__*/_createVNode("h3", { class: "subtitle-3" }, "Assign to site", -1)
const _hoisted_10 = { class: "grey-form-card" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-down el-icon--right" }, null, -1)
const _hoisted_12 = { class: "button-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_button = _resolveComponent("el-button")
  const _component_DropdownFilter = _resolveComponent("DropdownFilter")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form = _resolveComponent("el-form")
  const _component_LeavePreventPopup = _resolveComponent("LeavePreventPopup")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      "label-position": "top",
      "label-width": "100px",
      model: _ctx.form,
      rules: _ctx.rules,
      ref: "userForm"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_el_form_item, {
            label: "First name",
            prop: "first_name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.first_name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.first_name = $event)),
                maxlength: 30,
                onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.trim('first_name')))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Last name",
            prop: "last_name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.last_name,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.last_name = $event)),
                maxlength: 30,
                onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.trim('last_name')))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Job title",
            prop: "title"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.title,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.title = $event)),
                maxlength: 50,
                onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.trim('title')))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Email",
            prop: "email"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                disabled: _ctx.isEdit,
                modelValue: _ctx.form.email,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.email = $event)),
                maxlength: 40,
                onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.trim('email')))
              }, null, 8, ["disabled", "modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { class: "parent-item" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "phone-code-input",
                    label: "Country code",
                    prop: "country_code"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.country_code,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.country_code = $event)),
                        maxlength: 3,
                        "prefix-icon": "el-icon-plus",
                        onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.trim('country_code')))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    class: "phone-number-input",
                    label: "Phone number",
                    prop: "phone_number"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.phone_number,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.phone_number = $event)),
                        maxlength: 10,
                        onBlur: _cache[12] || (_cache[12] = ($event: any) => (_ctx.trim('phone_number')))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_el_form_item, {
            label: "Role",
            prop: "role_ids"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown, {
                class: "input-dropdown",
                trigger: "click",
                placement: "bottom-start"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_DropdownFilter, {
                        class: "form-dropdown-filter",
                        filterData: _ctx.state.roles
                      }, null, 8, ["filterData"])
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.role) + " ", 1),
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _hoisted_7,
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_el_form_item, {
            label: "Language",
            prop: "language"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.form.language,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.language = $event)),
                placeholder: "-",
                disabled: _ctx.languageDisabled
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.languageList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.code,
                      label: item.description,
                      value: item.code
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          })
        ]),
        (_ctx.state.isSystemAdmin)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _hoisted_9,
              _createVNode("div", _hoisted_10, [
                _createVNode(_component_el_form_item, {
                  label: "Site",
                  prop: "site_id"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown, {
                      class: "input-dropdown",
                      trigger: "click"
                    }, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_DropdownFilter, {
                              class: "form-dropdown-filter",
                              filterData: _ctx.state.sites
                            }, null, 8, ["filterData"])
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          disabled: !_ctx.showContactPersonCheckbox
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.site) + " ", 1),
                            _hoisted_11
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode("div", _hoisted_12, [
      _createVNode("button", {
        class: "button secondary",
        onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.cancel()), ["prevent"]))
      }, " Cancel "),
      _withDirectives(_createVNode("button", {
        class: "button",
        disabled: !_ctx.isRequiredFilled,
        onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.submitForm()), ["prevent"]))
      }, " Save ", 8, ["disabled"]), [
        [
          _directive_loading,
          _ctx.state.loading,
          void 0,
          {
            fullscreen: true,
            lock: true
          }
        ]
      ])
    ]),
    _createVNode(_component_LeavePreventPopup, {
      form: _ctx.form,
      disabled: _ctx.state.isSubmitted
    }, null, 8, ["form", "disabled"])
  ]))
}